__turbopack_context__.v({
  "className": "manrope_98acd17b-module__QaRP2a__className",
  "variable": "manrope_98acd17b-module__QaRP2a__variable",
});
